import styled from "styled-components";
import { Card } from "react-rainbow-components";

export const CardProduct = styled(Card)`
  width: calc(33% - 1rem);
  @media only screen and (max-width: 1024px) {
    width: calc(50% - 1rem);
  }
  @media only screen and (max-width: 600px) {
    width: calc(100% - 1rem);
  }
  aspect-ratio: 1;
  margin: 1rem 0.5rem;
  transition: all 0.5s ease;
  background-size: cover;
  background-position: center;
  position: relative;
  padding-top: 3rem;
  ${({ bgImage }: { bgImage?: string }) =>
    bgImage && `background-image: url("${bgImage}");`}
`;

export const BubleEdit = styled.div`
  background-color: #fff;
  border-radius: 9999px;
  width: 2rem;
  height: 2rem;
  position: absolute;
  top: 1rem;
  right: 1rem;
  cursor: pointer;
  transition: all 0.5s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    transition: all 0.5s ease;
    transform: scale(1.5);
  }
`;

export const TypeProduct = styled.p`
  background-color: #fff;
  border-radius: 9999px;
  width: fit-content;
  padding: 0 1rem;
  height: 2rem;
  position: absolute;
  top: 1rem;
  left: 1rem;
  text-align: center;
  vertical-align: middle;
  padding-top: 4px;
`;

export const CardContent = styled.div`
  width: 100%;
  height: 100%;
  transition: all 0.5s ease;
  overflow: scroll;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 1rem;
  background-image: linear-gradient(to top, #000a, #0009, #0007, #0006, #0000);
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  overflow-y: scroll;
  overflow-x: hidden;
`;

export const HeaderTitleCard = styled.h3`
  ${({ showMore }: { showMore?: boolean }) =>
    !showMore
      ? "overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;"
      : ""}
  color: #fff;
  @media only screen and (max-width: 768px) {
    font-size: 1rem;
  }
`;

export const Descriptions = styled.p`
  overflow: hidden;
  margin: 0;
  ${({ showMore }: { showMore?: boolean }) =>
    !showMore
      ? "text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical;"
      : "overflow: scroll;"}
  color: #fff;
  @media only screen and (max-width: 768px) {
    font-size: 0.75rem;
  }
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  overflow-y: scroll;
  overflow-x: hidden;
`;

export const ReadMoreButton = styled.div`
  cursor: pointer;
  text-decoration: underline;
  color: #ddd;
  &:hover {
    font-weight: 500;
  }
  margin-bottom: 0.5rem;
`;


export const Detail = styled.div`
  color: #fff;
  & > span {
    font-weight: 300;
  }
  @media only screen and (max-width: 768px) {
    font-size: 0.75rem;
  }
`;
